import { servicesInitialState } from "./states";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = servicesInitialState;

export const fetchServicesAsync = createAsyncThunk(
  "services/Async",
  async (input, thunkApi) => {
    const { successCallback, errorCallback } = input;
    const { getState, rejectWithValue } = thunkApi;
    const { admin, services } = getState();
    const config = {
      headers: {
        authorization: `Bearer ${admin.accessToken}`
      }
    };
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_END_POINT}demoSection/all`,
        config
      );
      if(successCallback) successCallback();
      return {
        services: response.data.sections,
        totalCount: response.data.sections?.length || 0,
      };
    } catch (error) {
      errorCallback(error);
      return rejectWithValue(error.response.data);
    }
  }
);

const servicesSlice = createSlice({
  name: "services",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchServicesAsync.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchServicesAsync.fulfilled, (state, action) => {
      state.isLoading = false;
      state.value = action?.payload?.services;
      state.totalCount = action?.payload?.totalCount;
    });
    builder.addCase(fetchServicesAsync.rejected, (state) => {
      state.isLoading = true;
    });
  }
});

export default servicesSlice.reducer;
// export const {
//   verifier,
//   activated,
//   setIndex,
//   setLimit,
//   setSearchText,
// } = servicesSlice.actions;
